// extracted by mini-css-extract-plugin
export default {"container":"AddCardModal_container__NtBGt","label":"AddCardModal_label__9ZNrk","input":"AddCardModal_input__RxQuq","saveButton":"AddCardModal_saveButton__99YoX"};